import { Controller } from "@hotwired/stimulus"

// Loads a validation status fragment for a catalog item from `srcValue` and
// injects it into this element. Only the instance currently visible in the
// layout (i.e. `offsetParent !== null`, so not inside an `md:hidden` /
// `hidden md:block` responsive wrapper) performs the fetch. Once the fetch
// completes, the result is broadcast to any sibling instances sharing the
// same `itemIdValue`, so the hidden variant is pre-populated if the user
// later resizes the viewport.
export default class extends Controller {
  static values = {
    src: String,
    itemId: String,
  }

  connect() {
    if (this.element.offsetParent === null) return

    const siblings = this.#siblingElements()
    if (
      siblings.some(
        (el) =>
          el.dataset.lazyValidationStatus === "loading" ||
          el.dataset.lazyValidationStatus === "loaded",
      )
    ) {
      return
    }

    this.#load(siblings)
  }

  #siblingElements() {
    const selector = `[data-controller~="catalog--lazy-validation-status"][data-catalog--lazy-validation-status-item-id-value="${this.itemIdValue}"]`
    return Array.from(document.querySelectorAll(selector))
  }

  async #load(targets) {
    targets.forEach((el) => (el.dataset.lazyValidationStatus = "loading"))
    try {
      const response = await fetch(this.srcValue, {
        headers: { Accept: "text/html" },
      })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)
      const html = await response.text()
      const frame = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector("turbo-frame")
      if (!frame) throw new Error("frame not found in response")
      targets.forEach((el) => {
        el.innerHTML = frame.innerHTML
        el.dataset.lazyValidationStatus = "loaded"
      })
    } catch {
      targets.forEach((el) => delete el.dataset.lazyValidationStatus)
    }
  }
}
